module.exports = __webpack_public_path__ + "media/images/Web_Points-c717aa4ba5e638ab8f1d05f8b4c82312.png";